import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { FlowsIndexPage } from "./pages/FlowsIndexPage";
import { FlowEditorPage } from "./pages/FlowEditorPage";
import { BuyerPreviewPage } from "./pages/BuyerPreviewPage";
import { SigninPage } from "./pages/SigninPage";
import { SourcesPage } from "./pages/SourcesPage";
import { RequireAuth } from "./components/RequireAuth";

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/flows" replace />} />
        <Route path="/signin" element={<SigninPage />} />
        <Route
          path="/flows"
          element={
            <RequireAuth>
              <FlowsIndexPage />
            </RequireAuth>
          }
        />
        <Route
          path="/sources"
          element={
            <RequireAuth>
              <SourcesPage />
            </RequireAuth>
          }
        />
        <Route
          path="/flows/:flowId"
          element={
            <RequireAuth>
              <FlowEditorPage />
            </RequireAuth>
          }
        />
        <Route
          path="/preview/:flowId/:nodeId"
          element={
            <RequireAuth>
              <BuyerPreviewPage />
            </RequireAuth>
          }
        />
        <Route path="*" element={<Navigate to="/flows" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
